import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import { RpqsActionConstant } from 'rpqs/reducers/RpqsReducer'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise2 } from 'utils/ActionUtils'
import WaitAction from 'wait/WaitAction'
import i18n from 'simple-react-i18n'
import { PATH_RPQS_REFERENCIAL_COLLECTIVITY, PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY } from 'home/constants/RouteConstants'
import { push } from '@lagunovsky/redux-react-router'

const RpqsAction = {
    promiseAllRpqs() {
        return genericPromise2(ApplicationConf.rpqs.rpqs())
    },

    fetchAllRpqs: () => dispatch => {
        return RpqsAction.promiseAllRpqs()
            .then((json = []) => {
                dispatch(RpqsActionConstant.receiveAllRpqs(json))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseCreateRpqs(body) {
        return genericPromise2(ApplicationConf.rpqs.rpqs(), { method: 'POST', body })
    },

    createRpqs: (rpqs) => dispatch => {
        return RpqsAction.promiseCreateRpqs(rpqs)
            .then(json => {
                if (json.insert) {
                    dispatch(push(`/rpqs/${json.year}/collectivite/${json.collectivityId}/dashboard`))
                    dispatch(ToastrAction.success(i18n.successfulCreation))
                }
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.createError + i18n.rpqs} : ${err}`))
                dispatch(ToastrAction.error(i18n.createError + i18n.rpqs))
            })
    },

    promiseUpdateRpqs(body) {
        return genericPromise2(ApplicationConf.rpqs.rpqs(), { method: 'PUT', body })
    },

    updateRpqs: (rpqs) => dispatch => {
        return RpqsAction.promiseUpdateRpqs(rpqs)
            .then(json => {
                if (!json.update) {
                    throw new Error()
                }
                dispatch(RpqsAction.fetchRpqs(rpqs.year, rpqs.collectivityId))
                dispatch(ToastrAction.success(i18n.rpqsSuccessfullyModified))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseRpqs(year, collectivityId) {
        return genericPromise2(ApplicationConf.rpqs.rpqsByKey(year, collectivityId))
    },

    fetchRpqs: (year, collectivityId) => dispatch => {
        return RpqsAction.promiseRpqs(year, collectivityId)
            .then((json = []) => {
                dispatch(RpqsActionConstant.receiveRpqs(json))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseDeleteRpqs(year, collectivityId) {
        return genericPromise2(ApplicationConf.rpqs.rpqsByKey(year, collectivityId), { method: 'DELETE' })
    },

    deleteRpqs(year, collectivityId) {
        return (dispatch) => {
            dispatch(WaitAction.waitStart())
            return this.promiseDeleteRpqs(year, collectivityId)
                .then((json) => {
                    if (json.delete) {
                        dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.deleteError + i18n.rpqs} : ${err}`))
                    dispatch(ToastrAction.error(i18n.deleteError + i18n.rpqs))
                    dispatch(WaitAction.waitStop())
                })
        }
    },
    
    promiseIndicators(year, collectivityId, egId) {
        return genericPromise2(ApplicationConf.rpqs.indicators(year, collectivityId, egId))
    },

    fetchIndicators: (year, collectivityId, egId) => dispatch => {
        return RpqsAction.promiseIndicators(year, collectivityId, egId)
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    // Valeurs de codes d'indicateurs sur plusieurs années (collectivité + EG) — sert à REF.002.
    promiseIndicatorValues(body) {
        return genericPromise2(ApplicationConf.rpqs.indicatorValues(), { method: 'POST', body })
    },

    fetchIndicatorValues: (body) => dispatch => {
        return RpqsAction.promiseIndicatorValues(body)
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseUpdateIndicators(body) {
        return genericPromise2(ApplicationConf.rpqs.updateIndicators(), { method: 'POST', body })
    },

    updateIndicators: (body) => dispatch => {
        return RpqsAction.promiseUpdateIndicators(body)
            .then(json => {
                if (json.update) {
                    dispatch(ToastrAction.success(i18n.elementUpdateSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.updateError} : ${err}`))
                dispatch(ToastrAction.error(i18n.updateError))
            })
    },

    promiseDuplicateRpqs(body) {
        return genericPromise2(ApplicationConf.rpqs.duplicate(), { method: 'POST', body })
    },

    duplicateRpqs: (body) => dispatch => {
        return RpqsAction.promiseDuplicateRpqs(body)
            .then(json => {
                if (json.insert) {
                    dispatch(ToastrAction.success(i18n.successfulCreation))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.createError + i18n.rpqs} : ${err}`))
                dispatch(ToastrAction.error(i18n.createError + i18n.rpqs))
            })
    },

    fetchEvents: (year, collectivityId, egId) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.events(year, collectivityId, egId))
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
                return []
            })
    },

    createEvent: (event) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.event(), { method: 'POST', body: event })
            .then(json => {
                if (json.insert) {
                    dispatch(ToastrAction.success(i18n.eventAddSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.createError + i18n.event} : ${err}`))
                dispatch(ToastrAction.error(i18n.createError + i18n.event))
            })
    },

    updateEvent: (event) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.event(), { method: 'PUT', body: event })
            .then(json => {
                if (json.update) {
                    dispatch(ToastrAction.success(i18n.eventUpdateSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.updateError + i18n.event} : ${err}`))
                dispatch(ToastrAction.error(i18n.updateError + i18n.event))
            })
    },

    deleteEvent: (event) => dispatch => {
        const { year, collectivityId, managementUnitId, number } = event
        return genericPromise2(ApplicationConf.rpqs.event(), { method: 'DELETE', body: { year, collectivityId, managementUnitId, number } })
            .then(json => {
                if (json.delete) {
                    dispatch(ToastrAction.success(i18n.eventDeleteSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.deleteError + i18n.event} : ${err}`))
                dispatch(ToastrAction.error(i18n.deleteError + i18n.event))
            })
    },

    fetchCollectivityEvents: (collectivityId, withManagementUnits) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.collectivityEvents(collectivityId, withManagementUnits))
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
                return []
            })
    },

    fetchManagementUnitEvents: (managementUnitId) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.managementUnitEvents(managementUnitId))
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
                return []
            })
    },

    createReferentialEvent: (event) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.referentialEvent(), { method: 'POST', body: event })
            .then(json => {
                if (json.insert) {
                    dispatch(ToastrAction.success(i18n.eventAddSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.createError + i18n.event} : ${err}`))
                dispatch(ToastrAction.error(i18n.createError + i18n.event))
            })
    },

    updateReferentialEvent: (event) => dispatch => {
        return genericPromise2(ApplicationConf.rpqs.referentialEvent(), { method: 'PUT', body: event })
            .then(json => {
                if (json.update) {
                    dispatch(ToastrAction.success(i18n.eventUpdateSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.updateError + i18n.event} : ${err}`))
                dispatch(ToastrAction.error(i18n.updateError + i18n.event))
            })
    },

    deleteReferentialEvent: (event) => dispatch => {
        const { collectivityId, managementUnitId, number } = event
        return genericPromise2(ApplicationConf.rpqs.referentialEvent(), { method: 'DELETE', body: { collectivityId, managementUnitId, number } })
            .then(json => {
                if (json.delete) {
                    dispatch(ToastrAction.success(i18n.eventDeleteSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.deleteError + i18n.event} : ${err}`))
                dispatch(ToastrAction.error(i18n.deleteError + i18n.event))
            })
    },

    fetchDocuments: (dirPath) => dispatch => {
        return genericPromise2(ApplicationConf.files.system.listFiles(), { method: 'POST', body: { path: dirPath } })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
                return []
            })
    },

    uploadDocument: (dirPath, filename, content) => dispatch => {
        return genericPromise2(ApplicationConf.files.system.uploadFile(), { method: 'POST', body: { dirPath, filename, content } })
            .then(json => {
                if (json.insert) {
                    dispatch(ToastrAction.success(i18n.addSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.addError} : ${err}`))
                dispatch(ToastrAction.error(i18n.addError))
            })
    },

    deleteDocument: (filePath) => dispatch => {
        return genericPromise2(ApplicationConf.files.system.deleteFile(), { method: 'DELETE', body: { path: filePath } })
            .then(json => {
                if (json.delete) {
                    dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                }
                return json
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.deleteError} : ${err}`))
                dispatch(ToastrAction.error(i18n.deleteError))
            })
    },

    promiseAllCollectivities() {
        return genericPromise2(ApplicationConf.rpqs.collectivite())
    },

    fetchAllCollectivities: () => dispatch => {
        return RpqsAction.promiseAllCollectivities()
            .then((json = []) => {
                dispatch(RpqsActionConstant.receiveCollectivities(json))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseCreateCollectivity(body) {
        return genericPromise2(ApplicationConf.rpqs.collectivite(), { method: 'POST', body })
    },

    createCollectivity: (collectivity, formattedLink) => dispatch => {
        return RpqsAction.promiseCreateCollectivity(collectivity)
            .then(json => {
                if (json.insert) {
                    dispatch(RpqsAction.updateCollectivity({
                        ...collectivity,
                        ...formattedLink(json.id),
                        id: json.id,
                    }, json.id))
                    dispatch(push(PATH_RPQS_REFERENCIAL_COLLECTIVITY + json.id))
                    dispatch(ToastrAction.success(i18n.successfulCreation))
                }
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.createError + i18n.collectivity} : ${err}`))
                dispatch(ToastrAction.error(i18n.createError + i18n.collectivity))
            })
    },

    promiseUpdateCollectivity(body) {
        return genericPromise2(ApplicationConf.rpqs.collectivite(), { method: 'PUT', body })
    },

    updateCollectivity: (collectivity, id) => dispatch => {
        return RpqsAction.promiseUpdateCollectivity(collectivity)
            .then(json => {
                if (json.update) {
                    dispatch(RpqsAction.fetchCollectiviteById(id))
                    dispatch(ToastrAction.success(i18n.collectivitySuccessfullyModified))
                } else {
                    throw new Error()
                }
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseCollectiviteById(id) {
        return genericPromise2(ApplicationConf.rpqs.collectiviteById(id))
    },

    fetchCollectiviteById: (id) => dispatch => {
        return RpqsAction.promiseCollectiviteById(id)
            .then((json = []) => {
                dispatch(RpqsActionConstant.receiveCollectivity(json))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    getCollectiviteById: (id) => dispatch => {
        return RpqsAction.promiseCollectiviteById(id)
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseDeleteCollectivity(id) {
        return genericPromise2(ApplicationConf.rpqs.collectivite(), { method: 'DELETE', body: { id } })
    },

    deleteCollectivity(id) {
        return (dispatch) => {
            dispatch(WaitAction.waitStart())
            return this.promiseDeleteCollectivity(id)
                .then((json) => {
                    if (json.delete) {
                        dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                        dispatch(push(PATH_RPQS_REFERENCIAL_COLLECTIVITY))
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.deleteError + i18n.collectivity} : ${err}`))
                    dispatch(ToastrAction.error(i18n.deleteError + i18n.collectivity))
                    dispatch(WaitAction.waitStop())
                })
        }
    },

    promiseAllManagementUnits() {
        return genericPromise2(ApplicationConf.rpqs.managementUnit())
    },

    fetchAllManagementUnits: () => dispatch => {
        return RpqsAction.promiseAllManagementUnits()
            .then((json = []) => {
                dispatch(RpqsActionConstant.receiveManagementUnits(json))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseCreateManagementUnit(body) {
        return genericPromise2(ApplicationConf.rpqs.managementUnit(), { method: 'POST', body })
    },

    createManagementUnit: (managementUnit, formattedLink) => dispatch => {
        return RpqsAction.promiseCreateManagementUnit(managementUnit)
            .then(json => {
                if (json.insert) {
                    dispatch(RpqsAction.updateManagementUnit({
                        ...managementUnit,
                        ...formattedLink(json.id),
                        id: json.id,
                    }, json.id))
                    dispatch(push(PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY + json.id))
                    dispatch(ToastrAction.success(i18n.successfulCreation))
                }
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.createError + i18n.managementUnit} : ${err}`))
                dispatch(ToastrAction.error(i18n.createError + i18n.managementUnit))
            })
    },

    promiseUpdateManagementUnit(body) {
        return genericPromise2(ApplicationConf.rpqs.managementUnit(), { method: 'PUT', body })
    },

    updateManagementUnit: (managementUnit, id) => dispatch => {
        return RpqsAction.promiseUpdateManagementUnit(managementUnit)
            .then(json => {
                if (json.update) {
                    dispatch(RpqsAction.fetchManagementUnitById(id))
                    dispatch(ToastrAction.success(i18n.managementEntitySuccessfullyModified))
                } else {
                    throw new Error()
                }
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseManagementUnitById(id) {
        return genericPromise2(ApplicationConf.rpqs.managementUnitById(id))
    },

    fetchManagementUnitById: (id) => dispatch => {
        return RpqsAction.promiseManagementUnitById(id)
            .then((json = []) => {
                dispatch(RpqsActionConstant.receiveManagementUnit(json))
                return json
            })
            .catch(err => {
                dispatch(WaitAction.waitStop())
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    getManagementUnitById: (id) => dispatch => {
        return RpqsAction.promiseManagementUnitById(id)
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    promiseDeleteManagementUnit(id) {
        return genericPromise2(ApplicationConf.rpqs.managementUnit(), { method: 'DELETE', body: { id } })
    },

    deleteManagementUnit(id) {
        return (dispatch) => {
            dispatch(WaitAction.waitStart())
            return this.promiseDeleteManagementUnit(id)
                .then((json) => {
                    if (json.delete) {
                        dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                        dispatch(push(PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY))
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.deleteError + i18n.managementUnit} : ${err}`))
                    dispatch(ToastrAction.error(i18n.deleteError + i18n.managementUnit))
                    dispatch(WaitAction.waitStop())
                })
        }
    },
}

export default RpqsAction
